module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "75px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("I would like to dedicate this book to Jim Fuller, who supported me throughout my jockey career. Without whom I probably would have never gotten started as a jockey. He was my boss, my coach, and my agent on the track. He was like a father figure during that part of my life. He was always there for me no matter what. Jim would always say “go get ’em tiger” before I would go to the jock’s room. I still hear him saying that to me every time I go after a new dream like writing this book. So, thanks Jim. I hope you’re training some great horses in heaven!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0